import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { KpiService } from "../../../../dashboardCommon/services/kpiService";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { AbsencesKpiCfgService, AbsencesKpiCfg } from "./absencesKpiCfg.service";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import moment from 'moment';
import { ApigeeService } from "src/app/auth/apigee/apigee.service";

export class AbsencesDetailServiceDataItem {
    public category: string;
    public workerId: number;
    public contractBeginDate: Date;
    public trialPeriodEndDate: Date;
    public absenceDate: Date;
    public absenceDescription: string;
    public workerName: string;
    public workerEmail: string;
    public workerPhone: string;
    public client: string;
    public name: string;
    public nif: string;
}

export class AbsencesDetailServiceData {
    public absences: AbsencesDetailServiceDataItem[];
    public updateTimestamp: Date;
}

@Injectable()
export class AbsencesDetailService extends KpiService<AbsencesDetailServiceData> {
    public getClassName() { return "AbsencesDetailService"; }

    constructor(
        private serviceCfg: AbsencesKpiCfgService,
        private apigeeService: ApigeeService,
        private officeSelectorService: OfficeSelectorService,
        private httpClient: HttpClient,
        injector: Injector
    ) {
        super(injector);
    }

    protected async update(): Promise<AbsencesDetailServiceData> {
        if (this.apigeeService.apiToken) {
            let result: AbsencesDetailServiceData = null;
            try {
                let cfg: AbsencesKpiCfg = this.serviceCfg.getCfg();
                let currentDate = moment();
                let date: string = "{0}{1}{2}".format(String(currentDate.year()).padStart(4, "0"), String(currentDate.month() + 1).padStart(2, "0"), String(currentDate.date()).padStart(2, "0"))
                let url = cfg.absences.detailEndpointPattern.format(this.officeSelectorService.selectedOffice.id, date);
                result = await this.httpClient.get<AbsencesDetailServiceData>(url).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters, "KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}
